import PropTypes from 'prop-types'
import HeroVariant from '@components/hero-variant/index'
import VideoSpotlight from '@components/video-spotlight/index'
import CategorySlider from '@components/category-slider/category-slider'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import TabPanelFull from '@components/tab-panel/tab-panel-full'
import TestimonialV2 from '@components/testimonialv2/index'
import Timeline from '@components/timeline/index'
import MarketingFormEmbed from '@components/marketing-form-embed/index'
import useStyles from './university-program.styles'

const UniversityProgram = (props) => {
  const {
    metaDataField,
    metaImage,
    metaDescription,
    photoSpotlight,
    listCardAccordionSection,
    testimonialsSection,
    marketingEmailForm,
    timelineHeader,
    timelineSubtitle,
    timelineStepsCollection,
    timelineBackgroundImage,
    timelineCtaText,
    timelineCtaLink,
  } = props

  const styles = useStyles()

  return (
    <div className={styles.root}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaDataField}
        description={metaDescription}
        canonical={`${defaults.baseUrl}workingolf/university-program`}
        openGraph={{
          title: metaDataField,
          description: metaDescription,
          type: 'website',
          url: `${defaults.baseUrl}workingolf/university-program`,
          images: [{ url: metaImage && metaImage.url }],
        }}
      />
      <HeroVariant universityPage {...props} />
      <VideoSpotlight videoSpotlight={photoSpotlight} />
      <TabPanelFull {...listCardAccordionSection?.accordionCollection?.items[0]} />
      <Timeline
        header={timelineHeader}
        supportText={timelineSubtitle}
        events={timelineStepsCollection.items}
        backgroundImage={timelineBackgroundImage}
        ctaText={timelineCtaText}
        ctaLink={timelineCtaLink}
        wrap
      />
      <CategorySlider {...props} />
      <TestimonialV2 testimonialsData={testimonialsSection} />
      <MarketingFormEmbed {...marketingEmailForm} />
    </div>
  )
}

UniversityProgram.propTypes = {
  metaDataField: PropTypes.string,
  metaImage: PropTypes.object,
  metaDescription: PropTypes.string,
  photoSpotlight: PropTypes.object,
  listCardAccordionSection: PropTypes.object,
  testimonialsSection: PropTypes.object,
  nextStepsHeadline: PropTypes.string,
  nextStepsDescription: PropTypes.string,
  nextStepsCardsCollection: PropTypes.object,
  marketingEmailForm: PropTypes.object,
  timelineStepsCollection: PropTypes.object,
  timelineHeader: PropTypes.string,
  timelineSubtitle: PropTypes.string,
  timelineBackgroundImage: PropTypes.object,
  timelineCtaText: PropTypes.string,
  timelineCtaLink: PropTypes.string,
}

export default UniversityProgram
